import React, { useEffect, useMemo, useRef, useState } from "react";
import { ActivityIndicator, Dimensions, Keyboard, Platform, TouchableOpacity, View } from "react-native";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, TypographyTypeDLS, IconTokens, TextAlignTokens } from "@voltmoney/schema";
import CustomHeader from "../../customHeader/CustomHeader";
import Typography from "../../typography/Typography";
import TextInput from "../../textInput/TextInput";
import { RegexConfig } from "../constants";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import BottomSheet from "../BottomSheet";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { isMobile } from "../../stack/utils";
import { getParameters, getScreenType } from "../utils";
import EmailSubtitle from "../../emailSubtitle/EmailSubtitle";
import { OtpInput } from "../OtpInput/OtpInput";
import NeedHelpDC from "../NeedHelpDC";
import * as Animatable from 'react-native-animatable';
import Icon from "../../icon/Icon";
const useKeyboardHeight = (screenHeight) => {
    const [keyboardHeight, setKeyboardHeight] = useState(0);
    useEffect(() => {
        const handleKeyboardDidShow = (event) => {
            const extraSpace = Platform.OS === 'ios' ? 0 : 20;
            const height = event.endCoordinates.height || 0;
            setKeyboardHeight(height + extraSpace);
        };
        const handleKeyboardDidHide = () => {
            setKeyboardHeight(0);
        };
        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', handleKeyboardDidShow);
        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', handleKeyboardDidHide);
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);
    const availableHeight = screenHeight ? screenHeight - keyboardHeight : undefined;
    return { keyboardHeight, availableHeight };
};
const EnterEmailPage = ({ height, isDisabled, needHelpAction, goBackAction, continueAction, errorAction, successAction, email, numberOfOtp = 6, resendTimer = 15, counter, caption, state, onChangeText, action, triggerAction, contactUsDetails, showErrorModal, errorMessage, extraSpace, closeModalAction, isFromJupiter, preFilledEmail }) => {
    const [inputValue, setInputValue] = useState(preFilledEmail ? preFilledEmail : "");
    const [isLoading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [modalHeight, setModalHeight] = useState(320);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const inputRef = useRef(null);
    const [otpLimitExceeded, setOtpLimitExceeded] = useState(false);
    const [isErrorState, setIsErrorState] = useState(false);
    const [isSuccessState, setIsSuccessState] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [seconds, setSeconds] = useState(resendTimer);
    const [isRunning, setIsRunning] = useState(false);
    const [successText, setSuccessText] = useState(false);
    const [loader, setLoader] = useState(false);
    const [btnLoader, setbtnLoader] = useState(false);
    const [currentState, setCurrentState] = useState(InputStateToken.DEFAULT);
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { keyboardHeight } = useKeyboardHeight(height);
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        const params = getParameters(window?.location?.href);
        isDarkMode = params?.isDarkMode;
    }
    useEffect(() => {
        setIsRunning(true);
    }, []);
    useEffect(() => {
        if (showNeedHelp)
            Keyboard.dismiss();
    }, [showNeedHelp]);
    useEffect(() => {
        setModalHeight(showErrorModal ? 236 : 350);
        if (showErrorModal)
            Keyboard.dismiss();
    }, [showErrorModal]);
    useEffect(() => {
        if (successText) {
            setTimeout(() => {
                setSuccessText(false);
            }, 3000);
        }
    }, [showTimer, seconds]);
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        if (state === 'SUCCESS')
            setIsSuccessState(true);
        else if (state === 'ERROR')
            setIsErrorState(true);
        else if (state === 'DISABLED')
            setOtpLimitExceeded(true);
        else {
            setIsErrorState(false);
            setOtpLimitExceeded(false);
        }
    }, [state, counter]);
    const handleReset = () => {
        setSeconds(resendTimer);
        setIsRunning(true);
        setLoader(false);
        setIsErrorState(false);
        setIsSuccessState(true);
    };
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    useEffect(() => {
        setDisabled(isDisabled);
    }, [isDisabled]);
    const handleCloseModal = async () => {
        setShowModal(false);
        await triggerAction(closeModalAction);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Verify email', needHelpAction: handleNeedHelp, goBackAction: goBackAction, hideNeedHelp: false, isDarkMode: isDarkMode ? true : false, triggerAction: triggerAction, showNeedHelpNewArch: true, hideGoBack: isFromJupiter }));
    }, []);
    const renderContent = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
            React.createElement(View, { style: { padding: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3B, label: "Enter your email", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
                React.createElement(View, { style: { marginTop: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "We\u2019ll use this to send important updates", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { marginTop: 12 } },
                    React.createElement(TextInput, { id: "tf_verifyEmailScreen_enterEmail", showErrorAnimation: true, extraSpace: 15, isLowerCase: true, value: inputValue, isFocus: true, clearEnabled: false, regex: RegexConfig.EMAIL, isDarkMode: isDarkMode ? true : false, type: InputTypeToken.EMAIL, state: currentState, title: "Email ID", keyboardType: KeyboardTypeToken.email, placeholder: "Enter email", onChangeText: (text) => {
                            setInputValue(text);
                            if (regex.test(text)) {
                                setCurrentState(InputStateToken.DEFAULT);
                            }
                            else
                                setCurrentState(InputStateToken.ERROR);
                        }, triggerAction: triggerAction, errorAction: errorAction, successAction: successAction, caption: { success: "", error: "Enter a valid email address" } })),
                React.createElement(View, { style: { marginTop: 8 } },
                    React.createElement(ButtonDLSBase, { id: "bt_verifyEmailScreen_continue", sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Continue', onPress: async () => {
                            setLoading(true);
                            if (continueAction)
                                await triggerAction({
                                    ...continueAction,
                                    payload: {
                                        ...continueAction.payload,
                                        value: inputValue,
                                    },
                                });
                            setShowModal(true);
                            setLoading(false);
                        }, isDisabled: currentState === InputStateToken.ERROR || disabled })))));
    };
    const renderSuccessModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: `Enter ${numberOfOtp}-digit OTP`, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(EmailSubtitle, { label: "OTP sent to", subLabel: email, iconUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png", iconName: undefined, isDarkMode: isDarkMode ? true : false })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(OtpInput, { id: 'tf_emailScreen_otp', numberOfDigits: numberOfOtp, ref: inputRef, editable: !btnLoader, isDarkMode: isDarkMode ? true : false, onTextChange: async (text) => {
                        if (onChangeText) {
                            onChangeText(text);
                        }
                        if (text.length === numberOfOtp && text[text.length - 1] >= '0' && text[text.length - 1] <= '9') {
                            if (action && triggerAction && !otpLimitExceeded) {
                                setbtnLoader(true);
                                setIsErrorState(false);
                                await triggerAction({
                                    ...action,
                                    payload: {
                                        ...action.payload,
                                        value: text,
                                        noOfOtpDigits: numberOfOtp,
                                        emailId: inputValue
                                    },
                                });
                                setbtnLoader(false);
                            }
                        }
                        else {
                            setIsErrorState(false);
                            setLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : 'blue', theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8, borderColor: isDarkMode ? 'white' : '#DFDFDE' },
                        pinCodeTextStyle: isDarkMode ? { fontSize: 15, color: 'white' } : { fontSize: 15 },
                        containerStyle: { width: 310 },
                    } }),
                React.createElement(View, { style: { marginTop: 18 } }),
                btnLoader && !isErrorState && !otpLimitExceeded && (React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: "#1434CB", size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter })))),
                btnLoader || (!isErrorState && !otpLimitExceeded) && (React.createElement(View, { style: { height: extraSpace } })),
                isErrorState && inputRef?.current?.clear(),
                (isErrorState || otpLimitExceeded) && (React.createElement(View, { style: {} },
                    React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: caption?.error ? caption?.error : "" })))),
                isSuccessState && (React.createElement(View, { style: {} },
                    React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Success_100, label: caption?.success ? caption?.success : "" })))),
                React.createElement(View, { style: {
                        paddingTop: 18,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { disabled: otpLimitExceeded, style: { marginLeft: 8 }, onPress: async () => {
                            if ((seconds === 0 && !otpLimitExceeded)) {
                                setSuccessText(true);
                                setShowTimer(false);
                                handleReset();
                                //@ts-ignore
                                inputRef?.current?.clear();
                                if (continueAction) {
                                    await triggerAction({
                                        ...continueAction,
                                        payload: {
                                            ...continueAction.payload,
                                            value: inputValue,
                                        }
                                    });
                                }
                            }
                            else
                                setShowTimer(true);
                        } },
                        React.createElement(Typography, { id: 'txt_emailScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0
                                ? ColorTokens.Primary_100
                                : isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                !successText && showTimer && seconds > 0 && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                        React.createElement(Typography, { label: `Please wait for ${seconds}s to resend OTP`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night })))),
                successText &&
                    React.createElement(View, { style: { marginTop: 10 } },
                        React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                            React.createElement(Typography, { label: `OTP has been resent.`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Secondary_100 }))))));
    };
    const renderErrorModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 2 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorMessage })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { id: "bt_confirmPanScreen_reEnterDetails", sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Edit details', onPress: handleCloseModal, isDisabled: false }))));
    };
    const modalContentPresenter = () => {
        return showErrorModal ? renderErrorModal() : renderSuccessModal();
    };
    const footerChild = () => {
        return showModal ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight + keyboardHeight, width: '100%', closeFunction: handleCloseModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: isDarkMode ? '0D141F' : 'transparent', hasDraggableIcon: false, sheetBackgroundColor: isDarkMode ? '#0D141F' : 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: false }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White, headerChild: headerChild, bottomChildren: React.createElement(React.Fragment, null,
            footerChild(),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })), heightHeader: Platform.OS === 'ios' ? 93 : 57 },
        React.createElement(React.Fragment, null, renderContent())));
};
export default EnterEmailPage;
